export default __webpack_public_path__ + "20f3f3246ab6bbe883636d1449d45eb5.png";